export default function (element, data) {
    let lastScrollTop = 0;
    const header = document.querySelector('.header__block');
    
    function handleScroll() {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        let top = header.offsetHeight * (-1) - 1 + "px";
        
        if (scrollTop > lastScrollTop) {
            // Прокрутка вниз
            header.style.top = top; // Скрываем шапку
        } else {
            // Прокрутка вверх
            header.style.top = "0"; // Показываем шапку
        }
        
        
        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // Для мобильных браузеров, где значение может быть отрицательным
    }
    
    window.addEventListener("scroll", handleScroll);
}